<template lang="pug">
  div.text-center
    h3 {{ translations.title.main }}

    v-row(justify="center")
      v-col(cols="12")
        i(v-if="ips.length < 1") {{ translations.empty }}
        v-chip(@click:close="deleteProviderIp(ip)" class="ma-2" color="primary" v-for="(ip,i2)  in ips", :key="i2" close) {{ ip }}
    v-divider
    v-row
      v-col(cols="12").mt-5
        ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
          v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(addIp)")
            v-col(cols="12")
              h3 {{ translations.title.add }}
            v-col(cols="12")
              ValidationProvider(rules="required|ip" v-slot="{ errors }")
                v-text-field(label="IP" v-model="data.ip")
                span.red--text.text--accent-2(v-if="errors.length > 0")
                  v-icon(color="red accent-2") mdi-alert
                  |  {{ errors[0] }}
            v-col(cols="12")
              v-btn(:disabled="invalid" text type="submit" color="primary") {{ translations.button.create }}
</template>

<script>
  export default {
    name: "ProviderIpList",
    props:{
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      ips:{
        type: Array,
        default: function(){
          return []
        }
      },
      providerId:{
        type: String,
        default:''
      }
    },
    data: () => ({
      emptyField:{},
      data:{
        provider: '',
        ip: ''
      }
    }),
    created(){
      this.emptyField = Object.assign({}, this.data);
    },
    methods:{
      addIp(){
        this.data.provider = this.providerId;
        this.$store.dispatch('addProviderIp', this.data).then(status=>{
          if (status == 200){
            this.clearFields();
          }
        });
      },
      deleteProviderIp(ip){
        let formSend = {
          data: {
            provider: this.providerId,
            ip: ip,
          }
        };
        this.$store.dispatch('deleteProviderIp', formSend.data);
      },
      clearFields(){
        this.data.ip = '';
        this.$refs.validator.reset();
      },
    },
  }
</script>

<style lang="sass">
</style>